import { Button } from '../button/Button';
import { withPersonalizedButtonStyle } from '../button/withPersonalizedButtonStyle';
import { styles } from './SecondaryButton.styles';

export const SecondaryButton = withPersonalizedButtonStyle(Button, styles);
